import axios from 'axios'

export default {
    getBrewMethods() {
        return axios.get('/brewMethod/v1')
            .then(response => {
                return response.data
            })
    }
}